import React from "react";
import { useGetFlexDatesData } from "./useGetFlexDatesData.js";
import FlexibleDateBestPriceInner from "./FlexibleDateBestPriceInner.js";
const FlexibleDateBestPrice = () => {
    const data = useGetFlexDatesData();
    if (!data) {
        return null;
    }
    const { dates, currentBestPrice, cheaperCount, isOneWay } = data;
    return (React.createElement(FlexibleDateBestPriceInner, { carouselSize: "large", dates: dates, currentBestPrice: currentBestPrice, cheaperCount: cheaperCount, isOneWay: isOneWay }));
};
export default FlexibleDateBestPrice;
